module.exports = __webpack_public_path__ + "img/two.c2ff72f7.png";